import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageToggle from '../../components/feature/LanguageToggle';

export default function CompassResourcesPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();

  const licenses = [
    {
      img: "https://public.readdy.ai/ai/img_res/caebbea8404ae81c314be16879e2e856.jpg",
      alt: "Gold Mining",
      badge: t('compass_gold_badge'),
      title: t('compass_gold_title'),
      desc: t('compass_gold_desc'),
      icon: 'ri-treasure-map-line',
      cta: t('compass_gold_cta'),
    },
    {
      img: "https://readdy.ai/api/search-image?query=Uranium%20mining%20site%20with%20modern%20extraction%20equipment%2C%20professional%20industrial%20photography%20of%20nuclear%20energy%20mineral%20deposits%2C%20clean%20energy%20resource%20development%2C%20advanced%20mining%20technology%20for%20uranium%20ore%2C%20sustainable%20nuclear%20fuel%20extraction%2C%20professional%20lighting%20showing%20mineral%20processing%2C%20safety%20protocols%20in%20uranium%20mining%20operations%2C%20contemporary%20mining%20infrastructure&width=800&height=500&seq=compass-uranium-001&orientation=landscape",
      alt: "Uranium Mining",
      badge: t('compass_uranium_badge'),
      title: t('compass_uranium_title'),
      desc: t('compass_uranium_desc'),
      icon: 'ri-flashlight-line',
      cta: t('compass_uranium_cta'),
    },
    {
      img: "https://readdy.ai/api/search-image?query=Clear%20quartz%20crystal%20formations%20and%20mineral%20deposits%2C%20high-quality%20industrial%20quartz%20mining%2C%20professional%20photography%20of%20crystalline%20mineral%20structures%2C%20pure%20white%20and%20transparent%20quartz%20rocks%2C%20technology-grade%20mineral%20extraction%2C%20detailed%20crystal%20formations%2C%20industrial%20applications%20of%20quartz%2C%20clean%20professional%20lighting%20showing%20mineral%20clarity%20and%20purity&width=800&height=500&seq=compass-quartz-001&orientation=landscape",
      alt: "Quartz Mining",
      badge: t('compass_quartz_badge'),
      title: t('compass_quartz_title'),
      desc: t('compass_quartz_desc'),
      icon: 'ri-smartphone-line',
      cta: t('compass_quartz_cta'),
    },
    {
      img: "https://readdy.ai/api/search-image?query=Copper%20ore%20mining%20operations%20with%20reddish-brown%20mineral%20deposits%2C%20professional%20industrial%20photography%20of%20copper%20extraction%20site%2C%20rich%20copper-colored%20rock%20formations%2C%20modern%20mining%20equipment%20for%20copper%20ore%2C%20sustainable%20metal%20mining%20operations%2C%20detailed%20mineral%20composition%20showing%20copper%20content%2C%20industrial%20photography%20with%20natural%20earth%20tones%2C%20renewable%20energy%20infrastructure%20materials&width=800&height=500&seq=compass-copper-001&orientation=landscape",
      alt: "Copper Mining",
      badge: t('compass_copper_badge'),
      title: t('compass_copper_title'),
      desc: t('compass_copper_desc'),
      icon: 'ri-plug-line',
      cta: t('compass_copper_cta'),
    },
    {
      img: "https://readdy.ai/api/search-image?query=Black%20sand%20mineral%20deposits%20with%20heavy%20metals%20and%20rare%20earth%20elements%2C%20close-up%20of%20dark%20magnetic%20sand%20containing%20valuable%20minerals%2C%20professional%20mining%20photography%20showing%20black%20sand%20extraction%2C%20high%20mineral%20content%20beach%20sand%2C%20industrial%20mineral%20processing%2C%20sustainable%20rare%20earth%20mining%2C%20detailed%20texture%20of%20black%20sand%20with%20metallic%20particles%2C%20advanced%20materials%20extraction&width=800&height=500&seq=compass-blacksand-001&orientation=landscape",
      alt: "Black Sand Mining",
      badge: t('compass_blacksand_badge'),
      title: t('compass_blacksand_title'),
      desc: t('compass_blacksand_desc'),
      icon: 'ri-rocket-line',
      cta: t('compass_blacksand_cta'),
    },
    {
      img: "https://readdy.ai/api/search-image?query=Iron%20ore%20mining%20operations%20with%20reddish-brown%20hematite%20deposits%2C%20large-scale%20iron%20extraction%20site%2C%20professional%20industrial%20photography%20of%20iron%20ore%20stockpiles%2C%20heavy%20mining%20equipment%20processing%20iron%20ore%2C%20steel%20industry%20raw%20materials%2C%20sustainable%20metal%20mining%2C%20rich%20red%20and%20brown%20earth%20tones%2C%20modern%20mining%20infrastructure%20for%20iron%20production&width=800&height=500&seq=compass-iron-001&orientation=landscape",
      alt: "Iron Ore Mining",
      badge: t('compass_iron_badge'),
      title: t('compass_iron_title'),
      desc: t('compass_iron_desc'),
      icon: 'ri-building-2-line',
      cta: t('compass_iron_cta'),
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img src="https://static.readdy.ai/image/23290c60640f0a2a61534c667a486e48/08e651986c1a2c862c6b7b398d1365c8.jpeg" alt="GDSATLAS Logo" className="h-12 w-auto" />
            </Link>
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-sm font-medium text-gray-700 hover:text-[#D4AF37] transition-colors whitespace-nowrap">{t('compass_nav_home')}</Link>
              <a href="#about" className="text-sm font-medium text-gray-700 hover:text-[#D4AF37] transition-colors whitespace-nowrap">{t('compass_nav_about')}</a>
              <a href="#licenses" className="text-sm font-medium text-gray-700 hover:text-[#D4AF37] transition-colors whitespace-nowrap">{t('compass_nav_licenses')}</a>
              <a href="#investment" className="text-sm font-medium text-gray-700 hover:text-[#D4AF37] transition-colors whitespace-nowrap">{t('compass_nav_investment')}</a>
              <a href="#contact" className="text-sm font-medium text-gray-700 hover:text-[#D4AF37] transition-colors whitespace-nowrap">{t('compass_nav_contact')}</a>
              <LanguageToggle />
              <button className="px-6 py-2 border-2 border-[#D4AF37] text-[#D4AF37] rounded-full text-sm font-semibold hover:bg-[#D4AF37] hover:text-[#0A1F44] transition-all whitespace-nowrap cursor-pointer">
                {t('compass_nav_cta')}
              </button>
            </div>
            <button className="md:hidden cursor-pointer" onClick={() => setIsMenuOpen(!isMenuOpen)}>
              <i className="ri-menu-line text-2xl text-gray-700"></i>
            </button>
          </div>
          {isMenuOpen && (
            <div className="md:hidden mt-4 pb-4 space-y-3">
              <Link to="/" className="block text-sm font-medium text-gray-700 hover:text-[#D4AF37]">{t('compass_nav_home')}</Link>
              <a href="#about" className="block text-sm font-medium text-gray-700 hover:text-[#D4AF37]">{t('compass_nav_about')}</a>
              <a href="#licenses" className="block text-sm font-medium text-gray-700 hover:text-[#D4AF37]">{t('compass_nav_licenses')}</a>
              <a href="#investment" className="block text-sm font-medium text-gray-700 hover:text-[#D4AF37]">{t('compass_nav_investment')}</a>
              <a href="#contact" className="block text-sm font-medium text-gray-700 hover:text-[#D4AF37]">{t('compass_nav_contact')}</a>
              <LanguageToggle className="mt-2" />
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Massive%20open%20pit%20gold%20mine%20in%20Mauritania%20Africa%20with%20terraced%20excavation%20levels%2C%20aerial%20drone%20view%20showing%20scale%20of%20mining%20operations%2C%20golden%20sunset%20lighting%20over%20mineral%20extraction%20site%2C%20heavy%20mining%20equipment%20and%20trucks%2C%20professional%20industrial%20photography%2C%20rich%20earth%20tones%20and%20golden%20minerals%2C%20sustainable%20resource%20development%2C%20dramatic%20landscape%20with%20modern%20mining%20infrastructure%20and%20organized%20operations&width=1920&height=1080&seq=compass-hero-001&orientation=landscape"
            alt="Compass Resources Mining"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A1F44]/85 via-[#0A1F44]/75 to-[#0A1F44]/85"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center w-full">
          <div className="mb-8">
            <img src="https://static.readdy.ai/image/23290c60640f0a2a61534c667a486e48/829f51ab4aab91f5690d98faedf27d9e.png" alt="Compass Resources Logo" className="h-24 w-auto mx-auto" />
          </div>
          <h1 className="text-6xl md:text-7xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            {t('compass_hero_title').split('\n').map((line, i) => (
              <span key={i}>{line}{i === 0 && <br />}</span>
            ))}
          </h1>
          <p className="text-xl text-gray-200 mb-12 max-w-3xl mx-auto">{t('compass_hero_subtitle')}</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="#licenses" className="px-8 py-4 bg-[#D4AF37] text-[#0A1F44] rounded-full text-base font-semibold hover:bg-[#C4A037] transition-all flex items-center whitespace-nowrap">
              {t('compass_hero_cta1')}
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a href="#investment" className="px-8 py-4 border-2 border-white text-white rounded-full text-base font-semibold hover:bg-white hover:text-[#0A1F44] transition-all whitespace-nowrap">
              {t('compass_hero_cta2')}
            </a>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
              <p className="text-4xl font-bold text-[#D4AF37] mb-2">1,352 km²</p>
              <p className="text-white/80 text-sm">{t('compass_hero_stat1_label')}</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
              <p className="text-4xl font-bold text-[#D4AF37] mb-2">5+</p>
              <p className="text-white/80 text-sm">{t('compass_hero_stat2_label')}</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
              <p className="text-4xl font-bold text-[#D4AF37] mb-2">{t('compass_hero_stat3')}</p>
              <p className="text-white/80 text-sm">{t('compass_hero_stat3_label')}</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
              <p className="text-4xl font-bold text-[#D4AF37] mb-2">{t('compass_hero_stat4')}</p>
              <p className="text-white/80 text-sm">{t('compass_hero_stat4_label')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-24 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <div className="inline-block px-4 py-2 bg-[#D4AF37]/20 rounded-full mb-6">
                <span className="text-[#0A1F44] text-sm font-semibold">{t('compass_about_tag')}</span>
              </div>
              <h2 className="text-5xl font-bold text-[#0A1F44] mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                {t('compass_about_title').split('\n').map((line, i) => (
                  <span key={i}>{line}{i === 0 && <br />}</span>
                ))}
              </h2>
              <p className="text-gray-600 text-base leading-relaxed mb-6">{t('compass_about_p1')}</p>
              <p className="text-gray-600 text-base leading-relaxed mb-8">{t('compass_about_p2')}</p>
              <div className="bg-[#FFF9F0] border-l-4 border-[#D4AF37] p-6 rounded-lg">
                <p className="text-[#0A1F44] font-medium text-base leading-relaxed">{t('compass_about_quote')}</p>
              </div>
            </div>
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20mining%20geologists%20examining%20rock%20samples%20and%20mineral%20deposits%20in%20Mauritania%2C%20field%20exploration%20team%20with%20safety%20equipment%2C%20geological%20survey%20work%20with%20modern%20technology%2C%20African%20mining%20professionals%20analyzing%20ore%20samples%2C%20natural%20outdoor%20lighting%2C%20high-quality%20corporate%20photography%20showing%20expertise%20and%20precision%2C%20sustainable%20mining%20practices%2C%20diverse%20team%20of%20experts&width=800&height=900&seq=compass-about-001&orientation=portrait"
                  alt="Mining Exploration"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mining Licenses Section */}
      <section id="licenses" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-[#D4AF37]/20 rounded-full mb-4">
              <span className="text-[#0A1F44] text-sm font-semibold">{t('compass_licenses_tag')}</span>
            </div>
            <h2 className="text-5xl font-bold text-[#0A1F44] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>{t('compass_licenses_title')}</h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">{t('compass_licenses_subtitle')}</p>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            {licenses.map((license, idx) => (
              <div key={idx} className="bg-gradient-to-br from-[#0A1F44] to-[#0A1F44]/90 rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer">
                <div className="relative h-64 overflow-hidden">
                  <img src={license.img} alt={license.alt} className="w-full h-full object-cover object-top" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A1F44] via-[#0A1F44]/50 to-transparent"></div>
                  <div className="absolute top-6 left-6">
                    <div className="bg-[#D4AF37] text-[#0A1F44] px-4 py-2 rounded-full font-bold text-sm">{license.badge}</div>
                  </div>
                </div>
                <div className="p-8">
                  <h3 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>{license.title}</h3>
                  <p className="text-white/80 text-base leading-relaxed mb-6">{license.desc}</p>
                  <div className="flex items-center text-[#D4AF37] font-semibold text-base">
                    <i className={`${license.icon} text-2xl mr-3`}></i>
                    {license.cta}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Investment Opportunities Section */}
      <section id="investment" className="relative py-32 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20mining%20operations%20in%20Mauritania%20at%20golden%20sunset%2C%20aerial%20view%20of%20successful%20mining%20infrastructure%2C%20professional%20business%20photography%20showing%20investment%20opportunity%2C%20contemporary%20mining%20facilities%20with%20organized%20operations%2C%20warm%20golden%20lighting%20symbolizing%20prosperity%2C%20economic%20growth%20and%20development%2C%20inspiring%20investment%20atmosphere%20with%20dramatic%20sky%2C%20African%20mining%20success%20story&width=1920&height=800&seq=compass-investment-bg-001&orientation=landscape"
            alt="Investment Opportunities"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#001E3C]/85"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-6xl md:text-7xl font-bold text-white mb-8 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              {t('compass_inv_title').split('\n').map((line, i) => (
                <span key={i}>{line}{i === 0 && <br />}</span>
              ))}
            </h2>
            <p className="text-xl text-white/90 mb-12 max-w-4xl mx-auto leading-relaxed">{t('compass_inv_subtitle')}</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {[
              { icon: 'ri-government-line', titleKey: 'compass_inv_card1_title', descKey: 'compass_inv_card1_desc' },
              { icon: 'ri-road-map-line', titleKey: 'compass_inv_card2_title', descKey: 'compass_inv_card2_desc' },
              { icon: 'ri-global-line', titleKey: 'compass_inv_card3_title', descKey: 'compass_inv_card3_desc' },
            ].map((card, i) => (
              <div key={i} className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center">
                <div className="w-16 h-16 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${card.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">{t(card.titleKey)}</h3>
                <p className="text-white/80 text-sm leading-relaxed">{t(card.descKey)}</p>
              </div>
            ))}
          </div>
          <div className="bg-[#D4AF37]/20 backdrop-blur-sm border-2 border-[#D4AF37] rounded-3xl p-12 text-center">
            <h3 className="text-3xl font-bold text-white mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>{t('compass_inv_cta_title')}</h3>
            <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">{t('compass_inv_cta_desc')}</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="#contact" className="inline-flex items-center px-8 py-4 bg-[#D4AF37] text-[#0A1F44] rounded-full text-base font-semibold hover:bg-[#C4A037] transition-all whitespace-nowrap">
                {t('compass_inv_cta1')}
                <div className="ml-3 w-8 h-8 bg-[#0A1F44] rounded-full flex items-center justify-center">
                  <i className="ri-arrow-right-line text-white text-sm"></i>
                </div>
              </a>
              <a href="#contact" className="inline-flex items-center px-8 py-4 border-2 border-white text-white rounded-full text-base font-semibold hover:bg-white hover:text-[#0A1F44] transition-all whitespace-nowrap">
                {t('compass_inv_cta2')}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-[#D4AF37]/20 rounded-full mb-4">
              <span className="text-[#0A1F44] text-sm font-semibold">{t('compass_contact_tag')}</span>
            </div>
            <h2 className="text-5xl font-bold text-[#0A1F44] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>{t('compass_contact_title')}</h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">{t('compass_contact_subtitle')}</p>
          </div>
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <div className="space-y-8">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#D4AF37]/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-map-pin-line text-[#D4AF37] text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-[#0A1F44] mb-2">{t('compass_contact_addr_label')}</h4>
                    <p className="text-gray-600 text-sm leading-relaxed">ZRF ND F Nord Sect1 - 444<br />Tevragh Zeina<br />Nouakchott – Mauritanie</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#D4AF37]/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-phone-line text-[#D4AF37] text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-[#0A1F44] mb-2">{t('compass_contact_phone_label')}</h4>
                    <p className="text-gray-600 text-sm leading-relaxed">+(222) 46427000<br />+(222) 44290990</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#D4AF37]/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-mail-line text-[#D4AF37] text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-[#0A1F44] mb-2">{t('compass_contact_email_label')}</h4>
                    <p className="text-gray-600 text-sm">contact@gds-atlas.com</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#D4AF37]/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-building-line text-[#D4AF37] text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-[#0A1F44] mb-2">{t('compass_contact_parent_label')}</h4>
                    <Link to="/" className="text-[#D4AF37] text-sm hover:underline">GDSATLAS Holding</Link>
                  </div>
                </div>
                <div className="bg-[#FFF9F0] border-l-4 border-[#D4AF37] p-6 rounded-lg">
                  <p className="text-[#0A1F44] font-medium text-sm leading-relaxed">
                    <strong>Compass Resources</strong> — {t('compass_contact_note')}
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-[#F8F9FA] rounded-3xl p-8">
              <h3 className="text-2xl font-bold text-[#0A1F44] mb-6">{t('compass_form_title')}</h3>
              <form className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('compass_form_name')}</label>
                  <input type="text" className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm" placeholder={t('compass_form_name_ph')} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('compass_form_email')}</label>
                  <input type="email" className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm" placeholder={t('compass_form_email_ph')} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('compass_form_message')}</label>
                  <textarea rows={5} className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm resize-none" placeholder={t('compass_form_message_ph')}></textarea>
                </div>
                <button type="submit" className="w-full px-8 py-4 bg-[#D4AF37] text-[#0A1F44] rounded-full text-base font-semibold hover:bg-[#C4A037] transition-all whitespace-nowrap cursor-pointer">
                  {t('compass_form_submit')}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0A1F44] py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-12 mb-12">
            <div className="md:col-span-2">
              <img src="https://static.readdy.ai/image/23290c60640f0a2a61534c667a486e48/829f51ab4aab91f5690d98faedf27d9e.png" alt="Compass Resources Logo" className="h-12 w-auto mb-6" />
              <p className="text-white/70 text-sm mb-6 leading-relaxed">{t('compass_footer_tagline')}</p>
              <p className="text-white/50 text-xs mb-6">{t('compass_footer_subsidiary')}</p>
              <Link to="/" className="inline-flex items-center text-[#D4AF37] text-sm hover:underline">
                <i className="ri-arrow-left-line mr-2"></i>
                {t('compass_footer_back')}
              </Link>
            </div>
            <div>
              <h4 className="text-[#D4AF37] text-sm font-bold mb-4">{t('compass_footer_links')}</h4>
              <ul className="space-y-3">
                <li><a href="#about" className="text-white/70 text-sm hover:text-[#D4AF37] transition-colors">{t('compass_footer_about')}</a></li>
                <li><a href="#licenses" className="text-white/70 text-sm hover:text-[#D4AF37] transition-colors">{t('compass_footer_licenses')}</a></li>
                <li><a href="#investment" className="text-white/70 text-sm hover:text-[#D4AF37] transition-colors">{t('compass_footer_investment')}</a></li>
                <li><a href="#contact" className="text-white/70 text-sm hover:text-[#D4AF37] transition-colors">{t('compass_footer_contact')}</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-[#D4AF37] text-sm font-bold mb-4">{t('compass_contact_tag')}</h4>
              <ul className="space-y-3">
                <li className="flex items-start text-white/70 text-sm"><i className="ri-map-pin-line text-[#D4AF37] mr-2 mt-1"></i><span>Nouakchott, Mauritanie</span></li>
                <li className="flex items-start text-white/70 text-sm"><i className="ri-phone-line text-[#D4AF37] mr-2 mt-1"></i><span>+(222) 46427000</span></li>
                <li className="flex items-start text-white/70 text-sm"><i className="ri-mail-line text-[#D4AF37] mr-2 mt-1"></i><span>contact@gds-atlas.com</span></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-white/10 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-white/50 text-sm mb-4 md:mb-0">{t('compass_footer_copyright')}</p>
              <div className="flex items-center space-x-4">
                <a href="#" className="w-10 h-10 flex items-center justify-center text-[#D4AF37] hover:bg-white/10 rounded-full transition-all"><i className="ri-linkedin-fill text-xl"></i></a>
                <a href="#" className="w-10 h-10 flex items-center justify-center text-[#D4AF37] hover:bg-white/10 rounded-full transition-all"><i className="ri-twitter-fill text-xl"></i></a>
                <a href="#" className="w-10 h-10 flex items-center justify-center text-[#D4AF37] hover:bg-white/10 rounded-full transition-all"><i className="ri-facebook-fill text-xl"></i></a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/22244290990"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center hover:bg-[#1ebe5d] hover:scale-110 transition-all duration-300 cursor-pointer"
        aria-label="Chat on WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-3xl"></i>
      </a>
    </div>
  );
}
